import React, { useState } from 'react'
import api from '@disco/api/server'
import Button from 'components/ui/button'
import Label from 'components/ui/label'

const DomainValidation = ({ email }: { email: string }) => {
  const [results, setResults] = useState<string>()
  const domain = email.split('@')[1]

  const handler = async () => {
    setResults(`Checking '${domain}'...\n`)
    let res

    try {
      let apiRes = await api.validateDomain(domain)
      res = Object.entries(apiRes.validation_result)
        .sort((a, b) => (a[0] < b[0] ? -1 : 1))
        .map(([k, v]: [string, { valid: boolean; reason: string }]) => {
          return k.padStart(12) + ' ' + (v.valid ? 'OK' : v.reason)
        })
        .join('\n')
    } catch (err) {
      res = err.toString()
    }

    setResults(r => r + '\n' + res)
  }

  let domainReservedError = domain === 'disco.ac'
  return (
    <div
      style={{
        fontSize: 12,
      }}
    >
      <br />
      <Label caption="Staff only: custom domains" />
      <Button
        disabled={domainReservedError}
        onClick={handler}
        caption={
          <span>
            Enable custom email domain for <b>{domain}</b>
          </span>
        }
      />
      {domainReservedError && (
        <Label
          caption={
            <span>
              Make sure that <b>Sender From Address</b> contains an address
              belonging to the domain needing to be verified.
            </span>
          }
        />
      )}
      <div>{results && <pre>{results}</pre>}</div>
    </div>
  )
}

export default DomainValidation
